import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { ReactComponent as NavigateArrow } from '../../../../assets/icons/device-management/navigate-back.svg';
import { AvailableTabProperties } from '../../../../interface/device-management.interface';
import TabsContainer from '../../../../shared-components/tabs-container/TabsContainer';

interface DeviceHubDetailsTabsProperties {
  containerTabs: AvailableTabProperties[];
  handleSwitchTab: (key: string) => void;
  deviceId?: string;
  children?: React.ReactNode;
}

/**
 * Component to display the device details tabs in EV Device Hub
 * @param {DeviceHubDetailsTabsProperties} properties - The properties passed to component
 * @returns {React.ReactElement} The rendered device hub details tabs component
 */
function DeviceHubDetailsTabs(properties: DeviceHubDetailsTabsProperties) {
  const { i18n } = useTranslation('devices');
  const navigate = useNavigate();
  const { containerTabs, handleSwitchTab, children } = properties;
  const location = useLocation();

  /**
   * Navigates back to the list page
   * @returns {void}
   */
  const handleBack = () => {
    // Navigate back to the ev-device-hub list page
    const updated = location.pathname.replace(/\/device-details\/.*$/, '/devices');
    navigate(updated);
  };

  return (
    <div className="container-tabs-wrap" dir={i18n.dir()}>
      <button type="button" className="navigate-arrow" onClick={handleBack}>
        <span>
          <NavigateArrow />
        </span>
        <div className="navigate-background" />
      </button>
      <TabsContainer containerTabs={containerTabs} handleSwitchTab={handleSwitchTab} />
      {children}
    </div>
  );
}

export default DeviceHubDetailsTabs;
